import {useQuery} from '@tanstack/react-query';
import {fetch} from '../services/MeteringRecordsService';

// FNP-534: single-record read for the detail view. MeteringRecord has a two-part
// key (customerId PK + sortKey SK), so the detail page supplies both. Read-only —
// no create/update/delete (the aggregator owns the lifecycle).
export const useMeteringRecord = (customerId?: string, sortKey?: string) => {

    const meteringRecordQuery = useQuery({
        queryKey: ['meteringRecord', customerId, sortKey],
        queryFn: () => fetch(customerId!, sortKey!),
        enabled: !!customerId && !!sortKey
    });

    return {
        record: meteringRecordQuery.data,
        loading: meteringRecordQuery.isLoading,
        // Surface error + fetched-but-empty so the detail page can show a
        // "not found" state instead of hanging on the loader forever when a key
        // doesn't resolve (e.g. a malformed/encoded key, or a deleted record).
        isError: meteringRecordQuery.isError,
        notFound: meteringRecordQuery.isFetched && !meteringRecordQuery.data,
        fetchRecord: meteringRecordQuery.refetch,
    };
};
